import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=03deee16&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=js"
export * from "./ColorField.vue?vue&type=script&lang=js"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=03deee16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03deee16",
  null
  
)

export default component.exports